export const LINK_BOOK_A_DEMO = "https://calendly.com/channelwill-parcelpanel/parcelpanel"
// From运营提供（大客户销售-方晓曼）条件Free & orders > 2000
export const LINK_BOOK_A_DEMO_OP = "https://calendly.com/channelwill-parcelpanel/parcelpanel-demo"
// Tracking & PPI 服务窗口 WhatsApp（Dashboard Banner / Explore more / Help Center / Protection Talk to an expert）
export const LINK_TRACKING_WHATSAPP = "https://wa.me/19196562190?text=Hi%2C%20I%E2%80%99m%20using%20CWILL%20Order%20Tracking%20and%20would%20like%20to%20learn%20more%20about%20your%20services"
